import React, { useContext, useEffect, useState } from "react";
import { Menu, MenuHandler, MenuList } from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";
import * as notifyApi from "../../../service/notifyApi";
import { HashLoader } from "react-spinners";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import { CurrentUserContext } from "../../../App";
import moment from "moment/moment";
import MenuInfoHospital from "./MenuInfoHospital";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "./MenuHospital.module.css";
import {
  faAngleRight,
  faBell,
  faLock,
  faSearch,
  faUserAlt,
} from "@fortawesome/free-solid-svg-icons";

function MenuHospital({ menuActive }) {
  const { userRole, setUserRole, setIsMessage } =
    useContext(CurrentUserContext);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [notifyList, setNotifyList] = useState([]);
  const [page, setPage] = useState(1);
  const [getNotificationTotal, setGetNotificationTotal] = useState(
    localStorage.getItem("Notification"),
  );
  const [openModalApprove, setOpenModalApprove] = useState(false);
  const [itemOnClickNotify, setItemOnClickNotify] = useState("");
  const [checkUserAfterLogin, setCheckUserAfterLogin] = useState(
    localStorage.getItem("user"),
  );
  const [informationHover, setInformationHover] = useState(false);
  const [pharmacogenomicsHover, setPharmacogenomicsHover] = useState(false);
  const [new_notify, setNew_nottify] = useState(false);

  const [open, setOpen] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (localStorage.getItem("Notification") === null) {
      setGetNotificationTotal(0);
    } else {
      // console.log(getNotificationTotal)
    }
    getRequestPermission();
    setUserRole(user); //ใช้อัพเดท route path ทุกครั้งถ้ามีการ อัพเดท
  }, [checkUserAfterLogin]);

  const [widtht, setWidth] = useState(0);

  useEffect(() => {
    const updateWindowDimensions = () => {
      const newWidth = window.innerWidth;
      setWidth(newWidth);
      // console.log("updating Width");
    };

    window.addEventListener("resize", updateWindowDimensions);

    return () => window.removeEventListener("resize", updateWindowDimensions);
  }, []);

  useEffect(() => {
    if (widtht > 767) {
      setOpen(false);
    }
  }, [widtht]);

  const getRequestPermission = async () => {
    setLoading(true);
    let res = await notifyApi.getNotification(page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        // console.log(res['data'])
        setNotifyList(res["data"]["notification_list"]);
        localStorage.setItem(
          "Notification",
          res["data"]["notification_list"].length,
        );
        setNew_nottify(res["data"]["is_new_badge"]);
      } else if (res["data"]["code"] === 401) {
        setIsMessage({ type: "error", data: "หมดเวลาใช้งาน" });
        localStorage.clear();
        navigate("/login");
        return;
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const setReadNotification = async () => {
    setLoading(true);
    let res = await notifyApi.setReadNotification(page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        getRequestPermission();
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  return (
    <header>
      <div className="md:hidden z-10 fixed top-0 left-0 right-0 flex justify-end bg-[#4F9C9D] text-white text-[16px] p-[5px_50px] gap-[30px]">
        <div className={styles.menuList}>
          <>
            <div
              className={`text-base cursor-pointer transition-colors duration-300 ease-in-out hover:underline${
                menuActive === "contact" ? styles.active : styles.topLink
              }`}
              onClick={() => navigate("/contact")}
            >
              ติดต่อเรา
            </div>
            <div
              className={`${
                menuActive === "ansQandA" ? styles.active : styles.topLink
              }`}
              onClick={() => navigate("/ansQandA")}
            >
              คำถามที่พบบ่อย
            </div>
            <div
              className={`${
                menuActive === "questionnaire" ? styles.active : styles.topLink
              }`}
              onClick={() => navigate("/questionnaire")}
            >
              แบบประเมินความพึงพอใจ
            </div>
          </>
        </div>
      </div>
      <div className="md:hidden lg:top-[30px] lg: z-[5] 2xl:px-5 fixed top-[34px] left-0 right-0 flex justify-between items-center bg-white pl-[50px] shadow-md w-full">
        <div className="2lg:gap-[12px] flex h-[80px] p-4 items-center gap-[30px] xxxl:gap-[20px] text-nowrap">
          <img
            className="h-full object-cover cursor-pointer"
            src={require("../../../asset/image/logo.svg").default}
            onClick={() => navigate("/")}
          ></img>
          <div
            className={`lg:text-sm flex text-black text-base items-center h-[80px] cursor-pointer ${
              menuActive === "home"
                ? "border-b-[3px] border-b-[#43A1EF]"
                : "border-b-0"
            }`}
            onClick={() => navigate("/")}
          >
            <div className="text-base font-bold">หน้าแรก</div>
          </div>
          <div
            className={`lg:text-sm flex text-black text-base items-center h-[80px] cursor-pointer ${
              menuActive === "news"
                ? "border-b-[3px] border-b-[#43A1EF]"
                : "border-b-0"
            }`}
            onClick={() => navigate("/news")}
          >
            <div className="text-base font-bold">ประชาสัมพันธ์</div>
          </div>
          <div
            className={`lg:text-sm flex text-black text-base items-center h-[80px] cursor-pointer ${
              menuActive === "about"
                ? "border-b-[3px] border-b-[#43A1EF]"
                : "border-b-0"
            }`}
            onClick={() => navigate("/about")}
          >
            <div className="text-base font-bold">เกี่ยวกับเรา</div>
          </div>
          <div
            className={`relative flex text-black text-base items-center h-[80px] cursor-pointer ${
              menuActive === "information"
                ? "border-b-[3px] border-b-[#43A1EF]"
                : "border-b-0"
            }`}
            onClick={() => setInformationHover(!informationHover)}
          >
            <div className="text-base font-bold">ข้อมูลที่เกี่ยวข้อง</div>
            {informationHover && (
              <div
                className="absolute top-20 w-64 h-52 bg-white rounded-bl-md shadow-lg"
                onMouseLeave={() => setInformationHover(false)}
              >
                <div className="relative">
                  <div
                    className="flex px-5 py-2 border-b border-gray-400"
                    onClick={() => navigate("/information/mapoperationRoom")}
                  >
                    แผนที่ห้องปฏิบัติการที่มีในระบบ
                  </div>
                  <div
                    className="flex justify-between px-5 py-2 border-b border-gray-400"
                    onClick={() => navigate("/information/pharmacogeneticTest")}
                    onMouseEnter={() => {
                      setPharmacogenomicsHover(true);
                    }}
                  >
                    <div>เภสัชพันธุศาสตร์</div>
                    <div>
                      <FontAwesomeIcon icon={faAngleRight}></FontAwesomeIcon>
                    </div>
                  </div>
                  {pharmacogenomicsHover && (
                    <div
                      className="xl:-left-[285px] absolute top-0 left-64 h-52 w-auto text-nowrap bg-gray-200 rounded-br-md shadow-lg"
                      onMouseEnter={() => {
                        setPharmacogenomicsHover(true);
                      }}
                      onMouseLeave={() => {
                        setPharmacogenomicsHover(false);
                      }}
                    >
                      <div
                        className="flex px-5 py-2 border-b border-gray-400"
                        onClick={() =>
                          navigate("/information/pharmacogeneticTest/HLAB5801")
                        }
                      >
                        HLA-B*58:01
                      </div>
                      <div
                        className="flex px-5 py-2 border-b border-gray-400"
                        onClick={() =>
                          navigate("/information/pharmacogeneticTest/HLAB1502")
                        }
                      >
                        HLA-B*15:02
                      </div>
                      <div
                        className="flex px-5 py-2 border-b border-gray-400"
                        onClick={() =>
                          navigate("/information/pharmacogeneticTest/ADRs")
                        }
                      >
                        อาการไม่พึงประสงค์หลังจากการใช้ยา
                      </div>
                      <div
                        className="flex px-5 py-2 border-b border-gray-400"
                        onClick={() =>
                          navigate("/information/pharmacogeneticTest/HLAB5701")
                        }
                      >
                        HLA-B*57:01
                      </div>
                      <div
                        className="flex px-5 py-2"
                        onClick={() =>
                          navigate("/information/pharmacogeneticTest/NAT2")
                        }
                      >
                        NAT2
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          <div
            className={`lg:text-sm flex text-base items-center h-[80px] cursor-pointer ${
              menuActive === "hospitalsetting"
                ? "text-[#FF9768] font-bold"
                : "text-[#000000]"
            } hover:text-[#FF9768]`}
            onClick={() => navigate("/hospital/setting")}
          >
            สำหรับโรงพยาบาล
          </div>
        </div>
        {/* ข้อมูลส่วนตัว */}

        <ul className="flex justify-end items-center text-3xl cursor-pointer top-7 right-0 p-0">
          <li
            onClick={() => {
              if (new_notify) {
                setReadNotification();
              }
            }}
          >
            <Menu>
              <MenuHandler>
                <button
                  onClick={() => {}}
                  className="flex h-full outline-none items-center mr-[20px] relative"
                >
                  <FontAwesomeIcon
                    icon={faBell}
                    alt="notify"
                    className="w-[16px] h-[18px] rounded-full lg:w-[28px] lg:h-[28px]"
                  />
                  {/* <img
                        className="w-[48px] h-[48px] rounded-full lg:w-[30px] lg:h-[30px]"
                        src="/notify.svg"
                        alt="notify"
                      /> */}
                  {new_notify ? (
                    <>
                      <div
                        className={`absolute border-[#FFFFFF] border-2 top-[-2px] right-[-3px] lg:top-[-2px] lg:right-[-2px] w-5 h-5 lg:w-3 lg:h-3 text-[0.65rem] leading-tight font-medium rounded-full flex items-center justify-center cursor-pointer hover:scale-110 transition-all duration-300 bg-[#EC3B3B] text-[#FFFFFF]`}
                      ></div>
                    </>
                  ) : null}
                </button>
              </MenuHandler>
              <MenuList
                className={`flex flex-col ${
                  notifyList.length > 0 ? "mt-7 w-80 rounded-2xl" : "rounded-xl"
                } z-[19]`}
              >
                <div className="h-full">
                  <div
                    className={`${
                      notifyList.length > 3
                        ? "overflow-y-scroll"
                        : "overflow-hidden"
                    } `}
                  >
                    <div
                      className={`${notifyList.length > 3 ? "h-[300px]" : ""} `}
                    >
                      {notifyList.length ? (
                        <>
                          {notifyList.map((i, idx) => (
                            <button
                              key={idx}
                              className="grid py-1 rounded-lg px-[15px] w-full"
                            >
                              <div
                                onClick={() => {}}
                                className="hover:rounded-lg hover:bg-[#fdf4f0] p-[5px]"
                              >
                                <div className="grid grid-cols-[auto_50px] justify-between font-bold py-[5px]">
                                  <div>{i["payload"]["topic"]}</div>
                                  <div className="text-[#FFC0A4]">
                                    {i["create_date"]["time"]}
                                  </div>
                                </div>
                                <div className="text-[#FF9768] flex justify-start py-[5px]">
                                  {i["payload"]["detail"]}
                                </div>
                                <div className="border-[1px] border-solid border-[#FF9768] w-full bg-[#FF9768] mt-[10px]"></div>
                              </div>
                            </button>
                          ))}
                        </>
                      ) : (
                        <div className="text-center text-[#2E2E2E] font-medium">
                          ไม่พบการแจ้งเตือน
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </MenuList>
            </Menu>
          </li>
          <li>
            <MenuInfoHospital />
          </li>
        </ul>
      </div>
      {/* mobile */}
      <div className="hidden z-10 fixed justify-end items-center gap-10 w-full text-3xl cursor-pointer top-0 right-0 px-5 py-2 pt-5 bg-white shadow-md md:flex">
        <ul>
          <Menu open={open}>
            <MenuHandler>
              <div>
                {open ? (
                  <XMarkIcon
                    onClick={() => setOpen(!open)}
                    className="w-6 stroke-[#FF9768] stroke-[3px]"
                  />
                ) : (
                  <Bars3Icon
                    onClick={() => setOpen(!open)}
                    className="w-6 stroke-[#FF9768] stroke-[3px]"
                  />
                )}
              </div>
            </MenuHandler>
            <MenuList className="flex flex-col items-center gap-y-3 rounded-3xl ">
              <div
                onClick={() => navigate("/")}
                className={`md:text-[14px] text-[18px] cursor-pointer ${
                  menuActive === "home" ? "text-[#FF9768]" : "text-[#000000]"
                }`}
              >
                หน้าแรก
              </div>
              <div
                onClick={() => navigate("/searchPatient")}
                className={`md:text-[14px] text-[18px] cursor-pointer ${
                  menuActive === "searchPatient"
                    ? "text-[#FF9768]"
                    : "text-[#000000]"
                }`}
              >
                ค้นหาข้อมูลผู้ป่วย
              </div>
              <div
                onClick={() => navigate("/news")}
                className={`md:text-[14px] text-[18px] cursor-pointer ${
                  menuActive === "news" ? "text-[#FF9768]" : "text-[#000000]"
                }`}
              >
                ประชาสัมพันธ์
              </div>
              <div
                onClick={() => navigate("/about")}
                className={`md:text-[14px] text-[18px] cursor-pointer ${
                  menuActive === "about" ? "text-[#FF9768]" : "text-[#000000]"
                }`}
              >
                เกี่ยวกับเรา
              </div>
              <div
                onClick={() => navigate("/information")}
                className={`md:text-[14px] text-[18px] cursor-pointer ${
                  menuActive === "information"
                    ? "text-[#FF9768]"
                    : "text-[#000000]"
                } `}
              >
                ข้อมูลที่เกี่ยวข้อง
              </div>
              <div
                onClick={() => navigate("/contact")}
                className={`md:text-[14px] text-[18px] cursor-pointer ${
                  menuActive === "contact" ? "text-[#FF9768]" : "text-[#000000]"
                } `}
              >
                ติดต่อเรา
              </div>
              <div
                onClick={() => navigate("/ansQandA")}
                className={`md:text-[14px] text-[18px] cursor-pointer ${
                  menuActive === "ansQandA"
                    ? "text-[#FF9768]"
                    : "text-[#000000]"
                } `}
              >
                คำถามที่พบบ่อย
              </div>
              <div
                onClick={() => navigate("/usagePolicy")}
                className={`md:text-[14px] text-[18px] cursor-pointer ${
                  menuActive === "usagePolicy"
                    ? "text-[#FF9768]"
                    : "text-[#000000]"
                } `}
              >
                แบบประเมินความพึงพอใจ
              </div>
            </MenuList>
          </Menu>
        </ul>
      </div>
    </header>
  );
}
export default MenuHospital;
